import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import Chart from 'react-apexcharts';

const Bar = ({ chartProps, ...props }) => {
    const theme = useTheme();
    const [graphState, setGraphState] = useState(updateState(chartProps, theme));
    useEffect(() => {
        setGraphState(updateState(chartProps, theme))
    }, [chartProps, theme])

    return (
        <Chart
            options={graphState.options}
            series={graphState.series}
            type='bar'
            width={'99.5%'}
            height={'99.5%'}

            style={{ width: '100%' }}
        />
    );
}

export default Bar;

const updateState = (chartProps, theme) => {
    return {
        series: chartProps.data,
        options: {
            chart: {
                type: 'bar',
                stacked: chartProps.stacked ?? false,
                toolbar: {
                    show: true
                },
                zoom: {
                    enabled: true,
                }
            },
            colors: theme.chartArray,
            plotOptions: {
                bar: {
                    horizontal: chartProps.horizontal ?? false,
                    columnWidth: '70%',
                    borderRadius: 3,
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: false,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                tickAmount: 3,
                categories: chartProps.xAxis,
                title: {
                    text: chartProps.xAxisLabel,
                    style: {
                        color: theme.text,
                    },
                },
                labels: {
                    style: {
                        colors: theme.text,
                    },
                    formatter: (val, index) => chartProps.xAxisFormatter ? chartProps.xAxisFormatter(val, index) : val,
                },
            },
            yaxis: {
                categories: chartProps.yAxis,
                title: {
                    text: chartProps.yAxisLabel,
                    style: {
                        color: theme.text,
                    },
                },
                labels: {
                    style: {
                        colors: theme.text,
                    },
                    formatter: (val, index) => chartProps.yAxisFormatter ? chartProps.yAxisFormatter(val, index) : val,
                },
            },
            fill: {
                opacity: 1,
                color: 'red'
            },
            legend: {
                position: chartProps.legendPosition ?? 'bottom',
                labels: {
                    colors: theme.text,
                },
            },
            tooltip: {
                y: {
                    formatter: (val) => chartProps.tooltipFormatter ? chartProps.tooltipFormatter(val) : val
                },
                theme: 'dark'
            }
        },
    };
}